import BigMoney from 'apps/employer_renewals/components/costs/BigMoney'
import { InvoiceProvider } from 'components/billing/InvoiceContext'
import { InvoiceCostBreakdown } from 'components/billing/InvoiceCostBreakdown'
import { InvoiceStatusBadge } from 'components/billing/InvoiceStatusBadge'
import { MemberInvoiceBreakdown } from 'components/billing/MemberInvoiceBreakdown'
import { convertGrapeMoneyToNumber } from 'utils'
import { type EmployersEmployerInvoice, type EmployersMemberInvoiceDetail } from 'utils/web_api.schemas'

interface ThatchInvoiceBreakdownProps {
  invoice: EmployersEmployerInvoice
  enrichedMemberInvoices: EmployersMemberInvoiceDetail[]
  onMemberClick: (memberInvoiceId: string) => void
}

export function ThatchInvoiceBreakdown ({
  invoice,
  enrichedMemberInvoices,
  onMemberClick,
}: ThatchInvoiceBreakdownProps) {
  return (
    <div className='mb-6'>
      <h3 className='heading-sm mb-4'>Bill breakdown</h3>
      <InvoiceProvider invoice={invoice} enrichedMemberInvoices={enrichedMemberInvoices}>
        <div className='rounded-2xl shadow-[0_1px_4px_rgba(0,0,0,0.1)] border border-gray-200 bg-white p-2'>
          <div className='mb-4 p-6'>
            <div className='flex items-center gap-4 mb-1'>
              <span className='body-md'>Healthcare costs</span>
            </div>
            <div className='flex items-center gap-4'>
              <BigMoney money={convertGrapeMoneyToNumber(invoice.total)} />
              <InvoiceStatusBadge
                invoice={invoice}
              />
            </div>
          </div>

          <InvoiceCostBreakdown />

          <hr className='my-4 border-gray-200' />

          <MemberInvoiceBreakdown onMemberClick={onMemberClick} />
        </div>
      </InvoiceProvider>
    </div>
  )
}
